import { selectAuthParams } from 'app/containers/AuthProvider/selectors';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to register authentication functions on the global window object.
 * This function is called from other frontends to access authentication parameters for making API requests
 */
export const useRegisterAuthFunctions = () => {
  const authParams = useSelector(selectAuthParams);

  const setWindowAuthService = useCallback(() => {
    window._MTI_AuthService = {
      getAuthParams: async () => authParams,
    };
  }, [authParams]);

  useEffect(() => {
    if (authParams) {
      setWindowAuthService();
    }
  }, [authParams, setWindowAuthService]);
};
